import {ComponentDefinition} from '@contentful/experiences-sdk-react';

export const StateGapMapContentfulComponentDefinition: ComponentDefinition = {
  id: 'stateGapMap',
  name: 'State Gap Map',
  category: '08: Advanced',
  tooltip: {
    description:
      'This component renders an interactive state-by-state map for access and participation gap exploration.',
  },
  variables: {},
};
